module.exports = __webpack_public_path__ + "static/img/fish7.e8eef39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish7.png
// module id = VBCK
// module chunks = 0